import angular from 'angular';

export default angular.module('cms.creator.scroll.lock', [])
    .directive('scrollLock', () => {
        return {

            link: function (scope, element) {
                let body = angular.element('body');
                let paddingRight = getScrollbarWidth(body);

                // Fixed elements
                const $_PAGETOP = $('.page-top');
                const $_BACKTOP = $('.back-top');
                const $_CHAT = $('.rocketchat-widget');
                const PAGETOP_PADDING_RIGHT = parseInt($_PAGETOP.css('padding-right'));
                const BACKTOP_PADDING_RIGHT = parseInt($_BACKTOP.css('right'));
                const CHAT_PADDING_RIGHT = parseInt($_CHAT.css('right'));

                element.on('mouseenter', () => {
                    body.css('overflow','hidden');
                    body.css('padding-right',paddingRight + 'px');
                    $_PAGETOP.css('padding-right',(paddingRight + PAGETOP_PADDING_RIGHT) + 'px');
                    $_BACKTOP.css('right',(paddingRight + BACKTOP_PADDING_RIGHT) + 'px');
                    $_CHAT.css('right',(paddingRight + CHAT_PADDING_RIGHT) + 'px');
                });

                element.on('mouseleave', () => {
                    body.css('overflow','auto');
                    body.css('padding-right','0');
                    $_PAGETOP.css('padding-right', PAGETOP_PADDING_RIGHT+'px');
                    $_BACKTOP.css('right', BACKTOP_PADDING_RIGHT+'px');
                    $_CHAT.css('right', CHAT_PADDING_RIGHT+'px');
                });

                /**
                 * Calculating browser/system specific width of scrollbar
                 * @param body
                 * @returns {number}
                 */
                function getScrollbarWidth(body) {
                    let outer = document.createElement("div");
                    outer.style.visibility = "hidden";
                    outer.style.width = "100px";
                    outer.style.msOverflowStyle = "scrollbar";

                    let tmp = $(body)[0].style.fontSize;
                    $(body)[0].style.fontSize = "14px";

                    let style = '<style>*::-webkit-scrollbar{width:.5em;}</style>';
                    $(body).append(style); //chrome blur-admin hack for ckeditor

                    $(body).append(outer);

                    let widthNoScroll = outer.offsetWidth;

                    outer.style.overflow = "scroll";
                    let inner = document.createElement("div");
                    inner.style.width = "100%";
                    outer.appendChild(inner);

                    let widthWithScroll = inner.offsetWidth;

                    outer.parentNode.removeChild(outer);
                    $(body)[0].style.fontSize = tmp;

                    return widthNoScroll - widthWithScroll;
                }
            }
        }
    }).name;





// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ScrollLock/ScrollLockDirective.js